import React, {useContext, useState} from 'react';

/* Organisms */
import { Modal } from 'js/components/organisms';

/* Atoms */
import { Icon } from 'js/components/atoms';

/* Symbols */
import toolTip from 'symbols/tooltip.svg';

/* Utilities */
import { trans } from 'js/utilities';

/* Context */
import vehicleOverviewContext from "../../../context/VehicleOverviewContext";

export default function VehicleOverviewToggles({ partnerModalContent, partnersToggle, filters, reversedState = false }) {
    const toggleFilters = filters.filter(filter => filter.key === 'partnervoertuig');

    const vOContext = useContext(vehicleOverviewContext);
    const { hasConversionVehicleList, useConversionVehicleList, updateState, updateFilters } = vOContext;

    const [modalOpen, setModalOpen] = useState(false);
    const [isActive, setIsActive] = useState(true);

    return (
        <>
            {hasConversionVehicleList ?
                <div className="col-12 col-xl-auto order-3 order-xl-1">
                    <div className={`vehicle-overview__toggle d-flex align-items-center gap-1 font-weight-semi-bold${useConversionVehicleList ? ` vehicle-overview__toggle--active` : ``}`}>
                        {trans('webstores_voertuigen_voorraad.filter.conversion')}
                        <div className="d-flex ml-auto ml-xl-0">
                            <div className={`custom-control custom-toggle`}>
                                <input
                                    id="use_conversion"
                                    className="custom-control-input"
                                    type="checkbox"
                                    checked={useConversionVehicleList}
                                    onChange={(event) => {
                                        event.persist();

                                        updateState('useConversionVehicleList', null, !useConversionVehicleList, true, true, useConversionVehicleList);
                                    }}
                                />
                                <label htmlFor="use_conversion"></label>
                            </div>
                        </div>
                    </div>
                </div>
            : null}
            {toggleFilters.length > 0 ?
                toggleFilters?.map((filterGroup) => {
                    const filterGroupPath = `${filters?.indexOf(filterGroup)}`;
                    const idOne = `filter.${filterGroupPath}`;
                    const modalContent = filterGroup.key === 'partnervoertuig' ? partnerModalContent : null;

                    if (filterGroup.key === 'partnervoertuig' && !partnersToggle) {
                        return null;
                    }

                    if (filterGroup?.filters?.[0]?.choices.length === 1 || filterGroup?.filters?.[0]?.choices?.[0]?.count === 0) {
                        return null;
                    }
                    
                    return (
                        <div key={filterGroupPath} className="col-12 col-xl-auto order-3 order-xl-1">
                            <div className={`vehicle-overview__toggle d-flex align-items-center gap-1 font-weight-semi-bold${isActive ? ` vehicle-overview__toggle--active` : ``}`}>
                                {trans(`webstores_voertuigen_voorraad.filter.${filterGroup.key}`)}
                                <div className="d-flex ml-auto ml-xl-0">
                                    {modalContent ?
                                        <div
                                            className="btn--tooltip btn--tooltip--pointer"
                                            onClick={() => {
                                                setModalOpen(true);
                                            }}
                                        >
                                            <Icon
                                                theme=""
                                                size={20}
                                                url={toolTip}
                                            />
                                        </div>
                                        : null}
                                    {filterGroup.filters.map((filter, index) => {
                                        const filterIndex = filterGroup.filters.indexOf(filter);
                                        const filterPath = `${filterGroupPath}.filters.${filterIndex}`;
                                        const idTwo = `${idOne}.filters.${filterIndex}`;

                                        return (
                                            filter.choices.map((choice) => {
                                                const choiceIndex = filter.choices.indexOf(choice);
                                                const choiceId = `${idTwo}.choices.${choiceIndex}`

                                                return (
                                                    <div key={choiceId} className={`custom-control custom-toggle${reversedState ? ` custom-toggle--reversed-state` : ``}${choice.key === '0' ? ` d-none` : ``}`}>
                                                        <input
                                                            id={choiceId}
                                                            name={`${filterPath}.choices`}
                                                            className="custom-control-input"
                                                            type="checkbox"
                                                            checked={choice.active}
                                                            onChange={(event) => {
                                                                event.persist();

                                                                updateFilters(`${filterPath}.choices`, (choices) => {
                                                                    if (event.target.checked) {
                                                                        return choices.map((choice, index) => ({
                                                                            ...choice,
                                                                            active: true,
                                                                        }))
                                                                    } else {
                                                                        return choices.map((choice, index) => ({
                                                                            ...choice,
                                                                            active: index === 0,
                                                                        }))
                                                                    }
                                                                });

                                                                setIsActive(!reversedState ? event.target.checked : !event.target.checked)
                                                            }}
                                                        />
                                                        <label htmlFor={choiceId}></label>
                                                    </div>
                                                )
                                            })
                                        )
                                    })}
                                </div>
                                {modalContent ?
                                    <Modal
                                        key={filterGroup.key}
                                        open={modalOpen}
                                        title={modalContent?.top_title}
                                        handleClose={() => setModalOpen(false)}
                                        bodyTitle={modalContent?.header_title}
                                        theme={modalContent?.accent_color}
                                    >
                                        {modalContent?.text ?
                                            <div dangerouslySetInnerHTML={{__html: modalContent?.text}}></div>
                                            : null}
                                    </Modal>
                                    : null}
                            </div>
                        </div>
                    )
                })
            : null}
        </>
    )
}
